/* NotesViewRenderer.js */

"use strict";

const Textarea = require("@gluenetworks/steve_ui_core").Control.Textfield.Textarea;
const _ = require("lodash");

class NotesViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("notes-view-gl");
        this._rootElem.component = this._model;

        this._noteTeaxtarea = new Textarea({
            placeholder: "Add Note"
        });

        this._rootElem.appendChild(this._noteTeaxtarea.renderer.rootElement);

        this._onSaveButtonClick = this._onSaveButtonClick.bind(this);
        this._onCancelButtonClick = this._onCancelButtonClick.bind(this);

        this._registerViewActions();
        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._noteTeaxtarea.shutdown().then(() => {
                this._noteTeaxtarea = undefined;
            });
            resolve();
        });
        return prom;
    }
    _registerViewActions() {
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Save",
            name: "save",
            handler: this._onSaveButtonClick
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Cancel",
            name: "cancel",
            handler: this._onCancelButtonClick
        });
    }
    _registerListeners() {
        this._model.on("Note", (this._onNote = this._onNote.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("Note");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setNote(this._model.getNote());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onNote(newVal) {
        this._setNote(newVal);
    }

    _onSaveButtonClick() {
        console.info("TRIGGER SAVE");
    }

    _onCancelButtonClick() {
        console.info("TRIGGER CANCEL");
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setNote(newVal) {
        if (!_.isUndefined(newVal)) {
            this._noteTeaxtarea.value = newVal;
        } else {
            this._noteTeaxtarea.value = "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = NotesViewRenderer;
